import { render, staticRenderFns } from "./deferred-payment.vue?vue&type=template&id=4994d58e&"
import script from "./deferred-payment.vue?vue&type=script&lang=js&"
export * from "./deferred-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports